import { useCallback } from "react";
import { fetchDashboardCounts, getCachedDashboardCounts } from "../api/dashboard.api";
import type { DashboardPermissions } from "../types/dashboard.types";
import { useCachedDashboardQuery } from "./useCachedDashboardQuery";

export const useDashboardCounts = (authenticated: boolean, permissions: DashboardPermissions) => {
  const fetcher = useCallback(
    (force?: boolean) =>
      fetchDashboardCounts(
        {
          canManageApplications: permissions.canManageApplications,
          canManageMutations: permissions.canManageMutations,
          canViewWaitingList: permissions.canViewWaitingList,
        },
        force,
      ),
    [permissions.canManageApplications, permissions.canManageMutations, permissions.canViewWaitingList],
  );
  return useCachedDashboardQuery(authenticated, getCachedDashboardCounts, fetcher);
};
